import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { IoWarningOutline } from "react-icons/io5";
import styles from "./LogoutModal.module.css";
import { IconBaseProps } from "react-icons";

const WarningIcon = IoWarningOutline as React.ComponentType<IconBaseProps>;

interface LogoutModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape" && show) onHide();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [show, onHide]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName={styles.logoutModalDialog}
      contentClassName={styles.logoutModalContent}
      backdropClassName={styles.logoutModalBackdrop}
    >
      <Modal.Body className={styles.logoutModalBody}>
        <div className={styles.iconContainer}>
          <WarningIcon size={48} className={styles.warningIcon} />
        </div>
        <p className={styles.message}>
          Are you sure you want to log out of your JigsawML account?
        </p>
      </Modal.Body>

      <Modal.Footer className={styles.logoutModalFooter}>
        <Button className={styles.cancelButton} onClick={onHide}>
          Cancel
        </Button>
        <Button className={styles.confirmButton} onClick={onConfirm}>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;
